import {
  BG_STYLES,
  COMMON_STYLES,
  TEXT_STYLES,
  TYPOGRAPHY,
  VARIANTS_STYLES,
} from '@dehaat/dds'

import { isWeb } from 'app/utils/helpers/responsiveUI'
import React from 'react'
import {
  View,
  StyleSheet,
  Pressable,
  Text,
  StyleProp,
  ViewStyle,
  ScrollView,
} from 'react-native'

interface Props {
  data: string[]
  activeIndex: number
  onMenuPress: (index: number) => void
  containerStyles?: StyleProp<ViewStyle>
}

const MenuDisplayHeader = ({
  data,
  activeIndex,
  onMenuPress,
  containerStyles,
}: Props) => {
  return (
    <View
      style={[
        COMMON_STYLES.ofHidden,
        COMMON_STYLES.b1,
        styles['br3/2'],
        BG_STYLES.bgWhite,
        containerStyles,
      ]}>
      <ScrollView
        horizontal
        showsHorizontalScrollIndicator={false}
        contentContainerStyle={isWeb ? COMMON_STYLES.flex1 : undefined}>
        <View
          style={[
            COMMON_STYLES.row,
            COMMON_STYLES.justifyBetween,
            COMMON_STYLES.flex1,
          ]}>
          {data.map((label, index) => (
            <Pressable
              key={index}
              style={[
                COMMON_STYLES['pv3/4'],
                COMMON_STYLES['ph3/2'],
                index === activeIndex && BG_STYLES.bgPrimary100,
                styles['br3/2'],
              ]}
              onPress={() => onMenuPress(index)}>
              <Text
                style={[
                  TYPOGRAPHY.TEXT1,
                  VARIANTS_STYLES.SEMI_EMPHASIZED,
                  TEXT_STYLES.textNeutral90,
                  index === activeIndex && TEXT_STYLES.textWhite,
                ]}>
                {label}
              </Text>
            </Pressable>
          ))}
        </View>
      </ScrollView>
    </View>
  )
}

const styles = StyleSheet.create({
  'br3/2': {
    borderRadius: 24,
  },
})

export default MenuDisplayHeader
